import React, { useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";
import translations from "./translations";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import Contact from "./pages/Contact";
import Footer from "./components/Footer";

function App() {
  const [lang, setLang] = useState("en");

  const t = translations[lang];

  return (
    <BrowserRouter>
      <div className="app">
        <Navbar t={t} lang={lang} setLang={setLang} />
        <main>
          <Routes>
            <Route path="/" element={<Home t={t} />} />
            <Route path="/contact" element={<Contact t={t} />} />
          </Routes>
        </main>
        <Footer t={t} />
      </div>
    </BrowserRouter>
  );
}

export default App;
